import style from "./style.module.scss";
import { NavLink } from "react-router-dom";

export default function MenuItem(props) {
  const { children, href, icon, ..._props } = props;

  // sem "icon" o children é renderizado exatamente como antes: quem passa o
  // próprio par de spans (SidebarAtendimento, com o contador à direita) depende
  // do justify-content: space-between do link
  const content = icon ? (
    <span className={style.label}>
      <span className={style.ico}>{icon}</span>
      {children}
    </span>
  ) : (
    children
  );

  return (
    <div className={style.menu}>
      {href ? (
        <NavLink {..._props} to={href}>
          {content}
        </NavLink>
      ) : (
        <button type="button" {..._props}>
          {content}
        </button>
      )}
    </div>
  );
}
